"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2394],{

/***/ 94082:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Layouts_GlobalLayout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./blocks/DialoguePresenter/DialoguePresenter.tsx
var DialoguePresenter = __webpack_require__(38114);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js
var IconButton = __webpack_require__(54799);
// EXTERNAL MODULE: ./customHooks/useLocalised/useLocalised.ts + 2 modules
var useLocalised = __webpack_require__(91933);
// EXTERNAL MODULE: ./data/constants.ts
var constants = __webpack_require__(84749);
// EXTERNAL MODULE: ./data/translationKeys.ts
var translationKeys = __webpack_require__(698);
// EXTERNAL MODULE: ./components/NavigationItem/NavigationItem.tsx
var NavigationItem = __webpack_require__(10493);
// EXTERNAL MODULE: ./components/icons/LittleEmperorsIcon.tsx
var LittleEmperorsIcon = __webpack_require__(21965);
// EXTERNAL MODULE: ./customHooks/useDialogue/useDialogue.ts
var useDialogue = __webpack_require__(82113);
// EXTERNAL MODULE: ./customHooks/useSignIn/useSignIn.ts
var useSignIn = __webpack_require__(37394);
// EXTERNAL MODULE: ./utils/memberAppSignInRedirect.ts
var memberAppSignInRedirect = __webpack_require__(37918);
// EXTERNAL MODULE: ./components/icons/BurgerMenuIcon.tsx
var BurgerMenuIcon = __webpack_require__(61063);
// EXTERNAL MODULE: ./components/icons/LittleEmperorsTextIcon.tsx
var LittleEmperorsTextIcon = __webpack_require__(15096);
// EXTERNAL MODULE: ./components/Button/Button.tsx
var Button = __webpack_require__(41107);
;// CONCATENATED MODULE: ./components/icons/BurgerMenuCloseIcon.tsx

var BurgerMenuCloseIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                "clip-path": "url(#A)",
                "fill-rule": "evenodd",
                fill: "#fff",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M3.497 3.493a.5.5 0 0 1 .707 0l16.305 16.305a.5.5 0 0 1-.707.707L3.497 4.2a.5.5 0 0 1 0-.707z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M20.502 3.491a.5.5 0 0 1 0 .707L4.198 20.503a.5.5 0 1 1-.707-.707L19.795 3.491a.5.5 0 0 1 .707 0z"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "A",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h24v24H0z"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var icons_BurgerMenuCloseIcon = (BurgerMenuCloseIcon);

// EXTERNAL MODULE: ./customHooks/useAuth/AuthProvider.tsx + 1 modules
var AuthProvider = __webpack_require__(52961);
;// CONCATENATED MODULE: ./blocks/Header/Header.tsx




















var Header = function() {
    var router = (0,next_router.useRouter)();
    var join_us_text = (0,useLocalised/* default */.Z)(translationKeys.join_us);
    var sign_in_text = (0,useLocalised/* default */.Z)(translationKeys.sign_in);
    var ref = (0,react.useContext)(useSignIn/* SignInContext */.f), setSignInState = ref.setState;
    var ref1 = (0,react.useContext)(useDialogue/* DialogueContext */.$), openDialogue = ref1.openDialogue, closeDialogue = ref1.closeDialogue, dialogueState = ref1.dialogueState;
    var isMobileMenuOpen = dialogueState.presentedDialogueType === constants/* MOBILE_MENU_DIALOGUE */.uN;
    var handleClickOnSignIn = (0,react.useCallback)(function() {
        var hotelRedirect = (0,memberAppSignInRedirect/* getHotelMemberSignInRedirectFromRouter */.e)(router.pathname, router.query);
        setSignInState(function(s) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, s), {
                redirectTo: hotelRedirect
            });
        });
        openDialogue(constants/* SIGN_IN_DIALOG */.jt);
    }, [
        openDialogue,
        router.pathname,
        router.query,
        setSignInState
    ]);
    var handleClickOnJoinUs = (0,react.useCallback)(function() {
        openDialogue(constants/* JOIN_US_DIALOG_STEP_1 */.le);
    }, [
        openDialogue
    ]);
    var handleBurgerMenuClick = (0,react.useCallback)(function() {
        openDialogue(constants/* MOBILE_MENU_DIALOGUE */.uN);
    }, [
        openDialogue
    ]);
    var signedIn = (0,AuthProvider/* useAuth */.a)().signedIn;
    var homePage = signedIn ? constants/* navigationPaths.WEB_APP_HOMEPAGE */.aY.WEB_APP_HOMEPAGE : constants/* navigationPaths.HOMEPAGE */.aY.HOMEPAGE;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "header-component",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "header-component__container",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "header-left",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationItem/* default */.Z, {
                            title: "Hotels",
                            path: constants/* navigationPaths.OUR_HOTELS */.aY.OUR_HOTELS,
                            className: "header-navigation-item"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationItem/* default */.Z, {
                            title: "Membership",
                            path: constants/* navigationPaths.MEMBERSHIP */.aY.MEMBERSHIP,
                            className: "header-navigation-item"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationItem/* default */.Z, {
                            title: "Gift cards",
                            path: constants/* navigationPaths.E_GIFT_CARD */.aY.E_GIFT_CARD,
                            className: "header-navigation-item"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationItem/* default */.Z, {
                            title: "MyLER",
                            path: constants/* navigationPaths.INDEPENDENT_TRAVEL_AGENT */.aY.INDEPENDENT_TRAVEL_AGENT,
                            className: "header-navigation-item"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationItem/* default */.Z, {
                            title: "Journal",
                            path: constants/* navigationPaths.TRAVEL_JOURNAL_ARTICLES */.aY.TRAVEL_JOURNAL_ARTICLES,
                            className: "header-navigation-item"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "burger-icon",
                    children: [
                        !isMobileMenuOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                            onClick: handleBurgerMenuClick,
                            title: "mobile-menu",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BurgerMenuIcon/* default */.Z, {})
                        }),
                        isMobileMenuOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                            onClick: closeDialogue,
                            title: "mobile-menu",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_BurgerMenuCloseIcon, {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "header-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: homePage,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                "area-label": "homepage",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LittleEmperorsIcon/* default */.Z, {
                                    color: constants/* colorConstants.brandColor */.Q_.brandColor
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: homePage,
                            className: "header-text-icon",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                "area-label": "homepage",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LittleEmperorsTextIcon/* default */.Z, {
                                    color: constants/* colorConstants.brandColor */.Q_.brandColor
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "header-rigth",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                            title: join_us_text,
                            onClick: handleClickOnJoinUs,
                            buttonType: Button/* LINK_BUTTON_TYPE */.II,
                            className: "header-join_us_text_button"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                            title: sign_in_text,
                            onClick: handleClickOnSignIn,
                            buttonType: Button/* LINK_BUTTON_TYPE */.II,
                            className: "header-navigation-item"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var Header_Header = (Header);

// EXTERNAL MODULE: ./blocks/Footer/Footer.tsx + 3 modules
var Footer = __webpack_require__(53114);
;// CONCATENATED MODULE: ./utils/header.ts
function formatCanonicalUrl(url) {
    if (!url.startsWith("http://") && !url.startsWith("https://")) {
        return url;
    }
    return url.replace(/^https?:\/\/(www\.)?/, "https://");
}
// gets first sentence or two from some copy
function getDescriptionFromContent(text) {
    if (!text) {
        return "";
    }
    var sentences = text.match(/[^.!?]+[.!?](?=\s+|$)/g);
    if (!sentences) {
        return text;
    }
    // help avoid splitting on common abbreviations  
    var abbreviations = /\b(?:[A-Z]\.|(?:[A-Z]\w{0,2}\.){2,}|e\.g\.|i\.e\.)/i;
    var combinedText = sentences[0].trim();
    // sensible minimum length for description
    if (combinedText.length > 90) {
        return combinedText;
    }
    for(var i = 1; i < sentences.length; i++){
        if (abbreviations.test(sentences[i])) {
            combinedText += " " + sentences[i].trim();
            continue;
        }
        combinedText += " " + sentences[i].trim();
        if (combinedText.length > 90) {
            return combinedText;
        }
    }
    return text;
}

;// CONCATENATED MODULE: ./blocks/Layouts/GlobalLayout.tsx



//Components



var GlobalLayout = function(param) {
    var children = param.children, memberships = param.memberships, currencies = param.currencies, countryCodes = param.countryCodes, metaData = param.metaData;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: metaData.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: metaData.description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: metaData.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: metaData.description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:site_name",
                        content: "Little Emperors"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:url",
                        content: metaData.url
                    }),
                    metaData.type && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:type",
                        content: metaData.type
                    }),
                    metaData.image && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: metaData.image
                    }),
                    metaData.author && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "author",
                        content: metaData.author
                    }),
                    metaData.publishedTime && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "article:published_time",
                        content: metaData.publishedTime
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:title",
                        content: metaData.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:description",
                        content: metaData.description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: formatCanonicalUrl(metaData.url)
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_Header, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "main-content-container",
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DialoguePresenter/* default */.Z, {
                memberships: memberships,
                currencies: currencies,
                countryCodes: countryCodes
            })
        ]
    });
};
/* harmony default export */ var Layouts_GlobalLayout = (GlobalLayout);


/***/ }),

/***/ 41107:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HB": function() { return /* binding */ FILLED_BUTTON_TYPE_DARK; },
/* harmony export */   "II": function() { return /* binding */ LINK_BUTTON_TYPE; },
/* harmony export */   "ME": function() { return /* binding */ FILLED_BUTTON_TYPE; },
/* harmony export */   "Wr": function() { return /* binding */ OUTLINED_BUTTON_TYPE_DARK; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var components_Spinner_Spinner__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95475);



var LINK_BUTTON_TYPE = "LINK_BUTTON_TYPE";
var FILLED_BUTTON_TYPE = "FILLED_BUTTON_TYPE";
var FILLED_BUTTON_TYPE_DARK = "FILLED_BUTTON_TYPE_DARK";
var OUTLINED_BUTTON_TYPE_DARK = "OUTLINED_BUTTON_TYPE_DARK";
var Button = function(param) {
    var title = param.title, onClick = param.onClick, _buttonType = param.buttonType, buttonType = _buttonType === void 0 ? FILLED_BUTTON_TYPE : _buttonType, _isLoading = param.isLoading, isLoading = _isLoading === void 0 ? false : _isLoading, className = param.className, htmlAttributes = param.htmlAttributes;
    var handleOnClick = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        if (isLoading) {
            return;
        }
        onClick();
    }, [
        isLoading,
        onClick
    ]);
    var getClass = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var classNameArray = [];
        var inititalClassName = "button-body-filled";
        switch(buttonType){
            case LINK_BUTTON_TYPE:
                inititalClassName = "button-body-link";
                break;
            case FILLED_BUTTON_TYPE_DARK:
                inititalClassName = "button-body-filled-dark";
                break;
            case OUTLINED_BUTTON_TYPE_DARK:
                inititalClassName = "button-body-outlined-dark";
            default:
                break;
        }
        classNameArray.push(inititalClassName);
        if (className) {
            classNameArray.push(className);
        }
        return classNameArray.join(" ");
    }, [
        buttonType,
        className
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
        type: htmlAttributes === null || htmlAttributes === void 0 ? void 0 : htmlAttributes.type,
        onClick: handleOnClick,
        className: getClass(),
        "area-label": title,
        style: htmlAttributes === null || htmlAttributes === void 0 ? void 0 : htmlAttributes.style,
        disabled: (htmlAttributes === null || htmlAttributes === void 0 ? void 0 : htmlAttributes.disabled) || false,
        children: [
            !isLoading && title,
            isLoading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Spinner_Spinner__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {})
        ]
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (Button);


/***/ }),

/***/ 87050:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E": function() { return /* reexport */ ImageComponent_ImageComponent; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/future/image.js
var future_image = __webpack_require__(61608);
var image_default = /*#__PURE__*/__webpack_require__.n(future_image);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/zod/v3/types.js + 4 modules
var types = __webpack_require__(45901);
;// CONCATENATED MODULE: ./components/ImageComponent/ImageComponent.tsx




var getMetadata = function(src, callback) {
    var img = new Image();
    img.src = src;
    img.onload = function() {
        callback(null, img);
    };
    img.onerror = function(err) {
        callback(err, null);
    };
    img.src = src;
};
var ImageComponent = function(param) {
    var src = param.src, alt = param.alt, style = param.style;
    var ref = (0,react.useState)(null), image = ref[0], setImage = ref[1];
    var imageStyle = {
        aspectRatio: (style === null || style === void 0 ? void 0 : style.aspectRatio) || "",
        height: (style === null || style === void 0 ? void 0 : style.height) || "",
        width: (style === null || style === void 0 ? void 0 : style.width) || "",
        maxHeight: (style === null || style === void 0 ? void 0 : style.maxHeight) || "",
        maxWidth: (style === null || style === void 0 ? void 0 : style.maxWidth) || "",
        objectFit: (style === null || style === void 0 ? void 0 : style.objectFit) || "cover",
        backgroundColor: (style === null || style === void 0 ? void 0 : style.backgroundColor) || "#f6f6f6"
    };
    (0,react.useEffect)(function() {
        if (src === "https://le-production.s3.eu-central-1.amazonaws.com/default.jpg") {
            setImage(null);
            return;
        }
        getMetadata(src, function(err, img) {
            if (img) {
                setImage(img);
            } else {
                setImage(null);
            }
        });
    }, [
        src
    ]);
    return image ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
        src: image,
        alt: alt,
        style: imageStyle
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            aspectRatio: (style === null || style === void 0 ? void 0 : style.aspectRatio) || "",
            height: (style === null || style === void 0 ? void 0 : style.height) || "",
            width: (style === null || style === void 0 ? void 0 : style.width) || "",
            maxHeight: (style === null || style === void 0 ? void 0 : style.maxHeight) || "",
            maxWidth: (style === null || style === void 0 ? void 0 : style.maxWidth) || "",
            objectFit: "cover",
            overflow: "hidden",
            backgroundColor: "#191919"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
            viewBox: "0 0 48 48 ",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            style: {
                height: "50%"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M44.1732 26.481C42.1482 26.4484 41.2199 26.3952 40.5566 26.2737C38.3368 25.8671 36.6934 25.0802 35.5163 23.86C34.9902 23.3148 34.238 22.2053 34.3125 22.0846C34.338 22.0434 34.4957 21.9805 34.663 21.9449C35.22 21.8261 37.8526 20.859 39.2843 20.2471C40.67 19.6549 41.0263 19.4166 41.0263 19.0818C41.0263 18.5793 41.0372 18.5823 34.7031 17.2555C31.4062 16.5649 28.6868 15.978 28.6601 15.9513C28.6334 15.9246 28.7668 15.7405 28.9565 15.5421C30.0039 14.4472 30.6656 12.9919 30.8408 11.3988C30.8763 11.0758 30.9383 10.8114 30.9786 10.8114C31.1107 10.8114 33.5113 6.76816 33.5113 6.5459C33.5113 6.25384 33.3011 6.08249 32.4735 5.70049C31.7862 5.38318 29.8115 4.70156 29.0268 4.51077C28.7026 4.43188 28.6189 4.36641 28.5771 4.15877C28.3336 2.94814 27.8933 2.16259 27.1578 1.37404C26.5562 0.728857 25.4421 0.121793 24.3127 0.0219209C21.9679 -0.185376 20.7144 1.13828 20.4191 1.4367C19.7726 2.09013 19.2925 2.96443 19.1267 3.79026L19.023 4.30655L18.4469 4.41922C17.7048 4.56441 15.6112 5.25764 14.7933 5.62894C14.0915 5.94772 13.8833 6.23369 14.078 6.61178C14.5092 7.44922 16.5707 10.744 16.7102 10.8187C16.8385 10.8873 16.8844 11.0187 16.8844 11.3165C16.8844 12.4118 17.5735 14.1164 18.4418 15.1698C18.7242 15.5123 18.9411 15.7925 18.924 15.7925C18.8871 15.7925 6.97603 18.3046 6.67534 18.3757C6.19601 18.4893 6.0032 19.0846 6.34552 19.3945C6.74873 19.7596 10.7109 21.3245 12.7165 21.9108C13.278 22.075 13.7523 22.2216 13.7703 22.2369C13.7884 22.2521 13.6918 22.4689 13.556 22.7188C12.7735 24.1573 11.0215 25.4017 8.94914 25.991C7.46968 26.4116 6.48833 26.5219 3.82717 26.5663C2.45804 26.5892 1.24806 26.6269 1.13842 26.6499C0.829904 26.7149 0.699178 27.1363 0.819988 27.6758C0.949247 28.2526 1.03807 28.4138 1.50902 28.9249C2.22159 29.6983 3.3294 30.073 4.91236 30.0761L5.76256 30.0777L6.58602 34.7533C7.1673 38.0547 7.45857 39.498 7.57673 39.6639C7.76856 39.9331 8.1224 40.0097 8.35396 39.8322C8.44111 39.7656 9.14446 38.408 9.91673 36.8159C10.6891 35.2236 11.3469 33.8949 11.3785 33.8632C11.4102 33.8315 11.4362 34.0559 11.4365 34.3617C11.437 35.1821 11.6792 36.5333 12.012 37.5724C12.5789 39.3433 13.4556 40.879 14.6908 42.2649L15.292 42.9394L14.7725 43.3626C13.4432 44.446 11.824 44.7236 10.3278 44.1247C9.60633 43.8358 9.3078 43.0517 9.71226 42.5074C10.0936 41.9942 10.6625 42.141 10.9933 42.8381C11.3241 43.5353 11.8713 43.6648 12.1814 43.1197C12.3007 42.9103 12.2966 42.8319 12.1463 42.4383C11.8025 41.5374 11.0603 40.9858 10.1867 40.9817C9.66121 40.9792 9.34467 41.1244 8.92805 41.5591C8.51869 41.9859 8.33608 42.467 8.33608 43.1188C8.33608 43.5696 8.39013 43.7565 8.64146 44.1755C9.38685 45.4188 11.9039 46.9219 14.2542 47.5272C15.3691 47.8145 16.8686 47.908 17.8095 47.7489C18.6744 47.6027 19.7753 47.0627 20.4039 46.4762L20.8705 46.041L21.6251 46.1997C22.6516 46.4154 24.6725 46.4841 25.731 46.3394L26.5801 46.2233L26.9693 46.5999C28.2717 47.8605 30.1354 48.2657 32.424 47.8323C33.0445 47.6408 33.6707 47.4703 34.3012 47.3239C36.4344 46.5636 38.383 45.2139 38.9259 44.0946C39.3095 43.3038 38.9814 42.0443 38.2452 41.4826C37.8031 41.1452 36.907 41.0603 36.4145 41.3093C35.8009 41.6194 35.3858 42.1245 35.1935 42.7952C35.0642 43.2463 35.3216 43.6069 35.7747 43.6097C36.0491 43.6113 36.2179 43.4417 36.447 42.934C36.6412 42.5038 37.104 42.2329 37.4079 42.3713C37.6234 42.4697 37.9264 43.0037 37.9264 43.2853C37.9264 43.3748 37.8398 43.5881 37.7339 43.7595C37.5128 44.1174 36.9042 44.384 35.9138 44.5566C34.8395 44.7438 33.5855 44.4054 32.7319 43.6978L32.3751 43.4022L33.0513 42.7313C35.1666 40.6325 36.4007 38.0271 36.7438 34.9359L36.8461 34.0143L38.1123 36.6617C39.6949 39.9706 39.6232 39.8518 40.0363 39.8518C40.2732 39.8518 40.4026 39.7931 40.5018 39.6404C40.5774 39.5241 40.7652 38.71 40.919 37.8312C41.0731 36.9525 41.4441 34.8485 41.7437 33.1556L42.2884 30.0777L43.1839 30.0763C44.6842 30.0739 45.795 29.7064 46.4929 28.9815C46.9552 28.5013 47.2215 27.8876 47.224 27.2963C47.2274 26.5105 47.3064 26.5316 44.1732 26.481ZM4.56278 28.8364C3.46774 28.7857 2.81313 28.5655 2.36453 28.0972L2.1012 27.8222H3.71013C4.59504 27.8222 5.33728 27.8538 5.35963 27.8927C5.38191 27.9315 5.43009 28.1697 5.46675 28.4222L5.53337 28.8812L4.56278 28.8364ZM38.2366 19.2511C38.3644 19.3025 38.2378 19.3856 37.7199 19.5897C32.183 21.772 27.9314 22.363 25.7384 21.2554C25.1981 20.9826 24.35 20.3702 24.35 19.9317C24.35 19.4779 24.358 18.2799 24.358 18.2799C24.358 17.8519 24.5489 17.8008 25.1509 17.63C25.4825 17.5359 26.1208 17.3634 26.5599 17.2104C26.9991 17.0573 27.4217 16.949 27.4993 16.9698C27.5768 16.9904 38.1434 19.2136 38.2366 19.2511ZM31.0967 6.44694C31.5679 6.62899 31.9724 6.79698 31.9957 6.82006C32.0188 6.84328 31.6641 7.47915 31.2075 8.23316L30.3775 9.60423L30.0422 9.53961C28.7039 9.28195 28.1251 9.20327 26.8417 9.1048C26.041 9.04325 25.3683 8.9794 25.3471 8.96289C25.3259 8.94639 25.3772 8.85715 25.4609 8.76448C25.7074 8.49193 25.9023 7.93403 25.9023 7.50098C25.9023 6.92762 25.7609 6.5068 25.4293 6.09389C25.1426 5.7372 25.1421 5.73336 25.3071 5.45374C25.5127 5.10545 25.7229 5.0958 27.2245 5.36464C28.4907 5.59145 29.9071 5.9873 31.0967 6.44694ZM20.5498 3.30678C20.948 2.42857 21.723 1.7252 22.6615 1.39019C23.3729 1.13611 24.5627 1.19807 25.2653 1.52559C25.9866 1.86179 26.6819 2.53221 27.028 3.22516C27.3776 3.92545 27.3986 4.1801 27.1 4.10792C26.9838 4.07981 26.5835 4.0277 26.2102 3.99189C25.6543 3.93867 25.5213 3.89405 25.4739 3.74473C25.3899 3.47967 24.8831 2.92904 24.5779 2.77112C24.4332 2.69622 24.0673 2.63495 23.7648 2.63495C23.0955 2.63495 22.481 2.97688 22.1955 3.50827C21.9993 3.87328 22.0851 3.84349 20.7593 4.007C20.2861 4.0654 20.2542 3.95853 20.5498 3.30678ZM24.6813 7.47608C24.6813 8.42997 23.354 8.70328 22.9418 7.8343C22.7392 7.40719 22.8905 6.92231 23.3053 6.66927C23.6593 6.45337 23.7466 6.44841 24.1601 6.62122C24.539 6.77963 24.6813 7.01295 24.6813 7.47608ZM17.1869 9.43155C16.9221 9.07584 15.5693 6.78509 15.5693 6.69256C15.5693 6.58087 16.1643 6.34727 17.4962 5.9359C18.6038 5.59376 19.5135 5.39353 20.7358 5.22267C22.045 5.03957 22.0064 5.03453 22.2343 5.42087L22.4362 5.76315L22.2074 6.00828C21.7738 6.47246 21.6532 6.83593 21.6903 7.56791C21.7175 8.10811 21.7749 8.32051 21.9767 8.62544L22.2292 9.00703L21.4589 9.06689C20.342 9.15362 19.1187 9.29972 18.1559 9.46113C17.3589 9.59479 17.3071 9.59332 17.1869 9.43155ZM18.3862 12.6635C18.1374 11.955 17.973 10.7995 18.109 10.7153C18.2499 10.6282 20.5593 10.3451 21.8631 10.2549C23.4809 10.1433 24.6065 10.1428 26.1757 10.253C26.9543 10.3077 28.0461 10.4241 28.602 10.5116L29.6129 10.6707L29.6413 11.0105C29.6836 11.5172 29.4148 12.5475 29.032 13.3463C28.6494 14.1443 27.5918 15.2894 26.8259 15.7344C26.2039 16.0959 24.5699 16.5446 23.8829 16.5427C21.4577 16.5356 19.1825 14.93 18.3862 12.6635ZM9.71939 19.5974C9.21436 19.4026 8.82463 19.2195 8.8534 19.1908C8.89292 19.1513 20.1324 16.7485 20.1411 16.7428C20.1498 16.7369 20.456 16.8757 20.8215 17.051C21.1871 17.2262 21.7824 17.4422 22.1444 17.531L22.8025 17.6922C22.8025 17.6922 22.6311 20.1899 22.4217 20.4279C20.7024 22.382 16.1704 22.0858 9.71939 19.5974ZM8.27749 37.2673C8.26038 37.2156 7.95117 35.5028 7.59049 33.4611C6.7627 28.7761 6.6421 28.105 6.58246 27.8518C6.54014 27.6723 6.57918 27.6419 6.89496 27.6091C7.09342 27.5886 7.28679 27.5647 7.32457 27.556C7.34223 27.5519 8.97442 27.2548 9.4101 27.1219C11.929 26.3532 13.7192 24.8121 14.8083 22.9585C15.046 22.5541 15.0441 22.4802 15.2368 22.5349C15.36 22.57 15.4754 22.574 15.4754 22.5921C15.4754 22.6102 14.9205 23.7626 14.2425 25.1531C11.8836 29.9905 8.32498 37.4107 8.27749 37.2673ZM19.2008 45.9085C17.9857 46.8359 15.6467 46.8547 13.3169 45.9559L12.5326 45.6533L13.2088 45.4815C14.0842 45.2589 15.0406 44.7519 15.6749 44.1739C15.9527 43.9207 16.1923 43.7117 16.2073 43.7093C16.2226 43.707 16.4633 43.8776 16.7423 44.0883C17.0214 44.2992 17.7638 44.7377 18.3922 45.0628L19.5346 45.654L19.2008 45.9085ZM34.1099 45.6771L34.7795 45.8489L34.3381 46.0403C32.7425 46.7322 30.7668 46.9864 29.5152 46.6609C28.9242 46.5073 28.0384 46.0577 28.045 45.9148C28.0473 45.8683 28.3375 45.7186 28.69 45.5819C29.4727 45.2785 30.5317 44.7406 30.975 44.4211C31.1559 44.2909 31.3395 44.1822 31.3833 44.1797C31.427 44.177 31.6595 44.3486 31.9 44.5608C32.4584 45.0538 33.2606 45.4589 34.1099 45.6771ZM35.4922 35.2732C35.0059 38.9218 32.6782 42.2296 29.408 43.9194C25.7176 45.8264 21.2676 45.6207 17.8844 43.3868C15.4009 41.7471 13.7362 39.4406 12.9588 36.5625C12.7392 35.7497 12.717 35.5013 12.7109 33.79C12.7013 31.0869 12.7116 31.0533 14.9182 26.5275L16.693 22.8881L18.4091 22.882C19.8662 22.8768 20.2361 22.8452 20.8593 22.6729C21.8054 22.4112 22.576 21.9964 23.0898 21.4728C23.3149 21.2431 23.522 21.0559 23.55 21.0566C23.578 21.0571 23.8058 21.265 24.0564 21.5183C24.9375 22.4096 26.2525 22.9005 28.0159 22.9969C28.9287 23.0468 30.6099 22.9364 31.2024 22.7876C31.3946 22.7393 31.5525 23.0315 33.2981 26.6651C34.6978 29.5784 35.2269 30.7768 35.3446 31.2994C35.5562 32.2389 35.6304 34.2368 35.4922 35.2732ZM41.3023 28.7697C41.196 29.3599 40.817 31.4873 40.46 33.4973C40.103 35.5073 39.7913 37.1714 39.7673 37.1955C39.7433 37.2194 32.6658 22.5284 32.6658 22.5108C32.6658 22.4836 32.8568 22.4197 33.0508 22.382C33.0816 22.3761 33.1874 22.5499 33.2857 22.7684C34.1644 24.7221 36.2996 26.4074 38.7678 27.0952C39.1535 27.2026 41.4097 27.6105 41.4606 27.6613C41.4799 27.6807 41.4086 28.1795 41.3023 28.7697ZM45.5481 28.1966C45.0845 28.6378 44.3365 28.856 43.2877 28.856H42.5083L42.569 28.5035C42.6023 28.3097 42.6526 28.0348 42.6809 27.8927L42.7321 27.6341H44.3215C45.4607 27.6341 45.911 27.6649 45.911 27.7428C45.911 27.8024 45.7477 28.0067 45.5481 28.1966Z",
                    fill: "#b9a57e"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M25.5578 11.5632C25.1107 11.5632 25.0917 11.5744 24.9843 11.8994C24.7759 12.5315 23.8766 12.8123 23.3607 12.4062C23.2273 12.3012 23.0651 12.0686 23.0003 11.8893C22.8881 11.5788 22.8608 11.5632 22.4317 11.5632C22.0411 11.5632 21.9809 11.5888 21.9809 11.7542C21.9809 12.0508 22.2464 12.6162 22.526 12.9143C23.3233 13.7651 24.7876 13.7281 25.5202 12.8389C25.7758 12.5287 26.0201 11.9573 26.0201 11.6698C26.0201 11.6048 25.8398 11.5632 25.5578 11.5632Z",
                    fill: "#b9a57e"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M33.3401 31.3935C32.1239 26.4869 27.4687 23.3412 22.5546 24.1052C20.566 24.4144 18.6977 25.3619 17.28 26.7804C13.8661 30.1959 13.4956 35.5011 16.4016 39.3595C17.3783 40.6563 18.4515 41.5164 20.0121 42.2534C21.4151 42.9158 22.2072 43.0828 23.9691 43.0879C25.8106 43.093 26.6486 42.9083 28.1963 42.1559C30.7178 40.9295 32.5592 38.6837 33.2831 35.9515C33.6199 34.6807 33.6455 32.6259 33.3401 31.3935ZM32.6211 35.753C32.1859 37.3068 31.5282 38.4888 30.4665 39.626C29.2469 40.9324 27.6083 41.8748 25.89 42.2583C24.9639 42.4649 23.077 42.467 22.1615 42.2624C18.7639 41.5029 16.0177 38.7486 15.3344 35.4152C15.1468 34.5002 15.1405 32.6526 15.3222 31.799C16.0649 28.3071 18.6996 25.6477 22.1857 24.8712C23.1547 24.6554 25.4164 24.7234 26.3644 24.9968C29.605 25.9313 32.0429 28.5651 32.7083 31.8507C32.9054 32.8238 32.8588 34.904 32.6211 35.753Z",
                    fill: "#b9a57e"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M18.094 37.5878C18.3007 37.5878 18.4757 37.5133 18.6189 37.3645C18.77 37.2073 18.8495 37.0212 18.8574 36.8062V29.9332C18.8495 29.7181 18.77 29.5362 18.6189 29.3873C18.4757 29.2302 18.3007 29.1516 18.094 29.1516H17.9389V29.0275H20.5514V29.1516H20.3963C20.11 29.1516 19.8913 29.2798 19.7402 29.5362C19.6686 29.6602 19.6329 29.7926 19.6329 29.9332V37.3272H21.3388C21.9273 37.3272 22.3766 37.1908 22.6868 36.9178C22.9969 36.6449 23.2554 36.2396 23.4622 35.702H23.5815L22.8896 37.7118H17.9389V37.5878H18.094Z",
                    fill: "#b9a57e"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M24.6179 37.5878C24.8246 37.5878 24.9996 37.5133 25.1427 37.3645C25.2938 37.2073 25.3734 37.0212 25.3813 36.8062V29.8587C25.3575 29.6602 25.274 29.4948 25.1308 29.3625C24.9877 29.2219 24.8167 29.1516 24.6179 29.1516H24.4747L24.4628 29.0275H27.9581C28.2046 29.0275 28.471 29.0027 28.7573 28.9531C29.0516 28.9035 29.2584 28.8538 29.3777 28.8042V30.3674H29.2584V30.1441C29.2584 29.9456 29.1908 29.776 29.0556 29.6354C28.9283 29.4948 28.7733 29.4204 28.5903 29.4121H26.1567V33.2456H28.1728C28.3319 33.2373 28.4671 33.1753 28.5784 33.0595C28.6897 32.9437 28.7454 32.799 28.7454 32.6253V32.4516H28.8647V34.4118H28.7454V34.2257C28.7454 34.0603 28.6897 33.9197 28.5784 33.8039C28.475 33.6881 28.3438 33.6261 28.1847 33.6178H26.1567V37.3272H27.8626C28.4512 37.3272 28.9005 37.1908 29.2107 36.9178C29.5208 36.6449 29.7793 36.2396 29.9861 35.702H30.1054L29.4135 37.7118H24.4628V37.5878H24.6179Z",
                    fill: "#b9a57e"
                })
            ]
        })
    });
};
// style={imageStyle}
// -----------------//
// type defenitions //
// -----------------//
var ImageComponentSchema = types/* object */.Ry({
    src: types/* string */.Z_().url(),
    alt: types/* string */.Z_(),
    style: types/* object */.Ry({
        aspectRatio: types/* string */.Z_().optional(),
        height: types/* string */.Z_().optional(),
        width: types/* string */.Z_().optional(),
        maxHeight: types/* string */.Z_().optional(),
        maxWidth: types/* string */.Z_().optional(),
        objectFit: types/* string */.Z_().optional(),
        backgroundColor: types/* string */.Z_().optional()
    }).optional()
});
// ----------------//
// function export //
// ----------------//
/* harmony default export */ var ImageComponent_ImageComponent = (ImageComponent);

;// CONCATENATED MODULE: ./components/ImageComponent/index.ts



/***/ }),

/***/ 37918:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ getHotelMemberSignInRedirectFromRouter; }
/* harmony export */ });
/**
 * When the user opens sign-in from a public hotel page, the member webapp expects
 * external-login?redirect=hotel/{numericId} (path after /ile/, no leading slash).
 */ function getHotelMemberSignInRedirectFromRouter(pathname, query) {
    if (pathname !== "/our-hotels/[idHotel]") {
        return undefined;
    }
    var raw = query.idHotel;
    var id = Array.isArray(raw) ? raw[0] : raw;
    if (typeof id !== "string" || !/^\d+$/.test(id)) {
        return undefined;
    }
    return "hotel/".concat(id);
}


/***/ })

}]);